module.exports = "https://web-assets-production.autolist.com/_next/static/images/swift-0c210fc362738997df161ea9279baf84.png";